// src/index.ts
var PricingType = /* @__PURE__ */ ((PricingType2) => {
  PricingType2["Monthly"] = "MONTHLY";
  PricingType2["Yearly"] = "YEARLY";
  return PricingType2;
})(PricingType || {});
var PRICING_CONFIG = {
  // Yearly discount percentage (yearly is 15% cheaper than monthly)
  yearlyDiscountPercent: 20,
  // Pricing tiers: monthly base prices
  tiers: [
    { maxRooms: 10, monthlyPrice: 11.25 },
    { maxRooms: 50, monthlyPrice: 7.5 },
    { maxRooms: 100, monthlyPrice: 6.25 },
    { maxRooms: 150, monthlyPrice: 5.625 },
    { maxRooms: 250, monthlyPrice: 5 },
    { maxRooms: Infinity, monthlyPrice: 4.375 }
  ]
};
function price(type, amountOfRooms) {
  if (!Object.values(PricingType).includes(type)) {
    throw new Error(
      `Invalid pricing type: ${type}. Must be 'MONTHLY' or 'YEARLY'.`
    );
  }
  if (!Number.isInteger(amountOfRooms) || amountOfRooms <= 0) {
    throw new Error("Amount of rooms must be a positive integer.");
  }
  const tier = PRICING_CONFIG.tiers.find((t) => amountOfRooms <= t.maxRooms);
  if (!tier) {
    throw new Error("No pricing tier found for room count.");
  }
  let unitPriceEuros = tier.monthlyPrice;
  if (type === "YEARLY" /* Yearly */) {
    const discountMultiplier = 1 - PRICING_CONFIG.yearlyDiscountPercent / 100;
    unitPriceEuros = tier.monthlyPrice * discountMultiplier;
  }
  const unitPrice = Math.round(unitPriceEuros * 100);
  const totalPrice = unitPrice * amountOfRooms;
  return { unitPrice, totalPrice };
}
export {
  PricingType,
  price
};
//# sourceMappingURL=index.js.map